var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1480,
    height: 177,
    viewBox: "0 0 1480 177",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFF",
    strokeOpacity: 0.1,
    d: "M1480 0 1439.40086 0C1426.1468 0 1415.40266 10.7452 1415.40266 24L1415.40266 62C1415.40266 75.2548 1404.65831 86 1391.40435 86L0 86M1480 175 1439.40086 175C1426.1468 175 1415.40266 164.255 1415.40266 151L1415.40266 113C1415.40266 99.745 1404.65831 89 1391.40435 89L0 89",
    transform: "translate(0 1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLines);
export default __webpack_public_path__ + "static/media/lines.17a95aa1765601a217ea3799d9cd0001.svg";
export { ForwardRef as ReactComponent };